declare var AmazonCognitoAdvancedSecurityData;
export default window.AmazonCognitoAdvancedSecurityData;
